import axios from '@/request';
import qs from 'qs';

export default {
  async getList(params: any) {
    return axios.get('system-setting/list', { params });
  },
  async save(params: any) {
    return axios.post('system-setting/save', qs.stringify(params));
  },
  async add(params: any) {
    return axios.post('system-setting/add', qs.stringify(params));
  },
  async edit(params: any) {
    return axios.post('system-setting/edit', qs.stringify(params));
  },
  async delete(params: any) {
    return axios.post('system-setting/delete', qs.stringify(params));
  },
  async detail(params: any) {
    return axios.get('system-setting/detail', { params });
  }
};
